module.exports = __webpack_public_path__ + "static/img/0001眼保健.ea64851.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0001眼保健.jpg
// module id = vSt+
// module chunks = 0